import React, { useState, useEffect, useContext } from "react";
import Container from "react-bootstrap/Container";
import {
  Row,
  Col,
  DatePicker,
  Checkbox,
  Form,
  InputNumber,
  Select,
  Spin,
  message,
} from "antd";
import Image from "react-bootstrap/Image";

import topAlertIcon from "@/assets/top_alert_icon.png";
import palletIcon from "@/assets/pallet_icon@3x.png";
import boxIcon from "@/assets/box_icon@3x.png";
import startIcon from "@/assets/Start@3x.png";
import endIcon from "@/assets/Stop@3x.png";
import calendarIcon from "@/assets/calendar.png";
import arrowIcon from "@/assets/arrow.png";

import { USCities } from "@/USCities";
import dayjs from "dayjs";

import JSONBig from "json-bigint";
import { BASE_API_URL } from "@/network.config";

// import { glogEvent } from "firebase/analytics";
import { glogEvent } from "@/components/firebaseConfig";

import { useIntl } from "react-intl";

import { AppContext } from "@/Context";

import DatePickerLocaleEN from "antd/lib/date-picker/locale/en_US";
import DatePickerLocaleZH from "antd/lib/date-picker/locale/zh_CN";

const { RangePicker } = DatePicker;

export default function (props) {
  const { currentLanguage } = useContext(AppContext);

  const [addressForm] = Form.useForm();
  const [cargoForm] = Form.useForm();

  const intl = useIntl();

  const [messageApi, contextHolder] = message.useMessage();
  const showAlertMessage = (content) => {
    messageApi.open({
      type: "error",
      content: content,
      style: {
        marginTop: "30vh",
      },
    });
  };

  const [isPallet, setIsPallet] = useState(true);

  const nextStep = () => {
    let addressInfo = addressForm.getFieldsValue();
    let cargoInfo = cargoForm.getFieldsValue();
    const pickup_zipcode = addressInfo["pickup_postal_code"];
    const pickup_item = USCities.find(
      (entry) => entry.value === pickup_zipcode
    );
    const delivery_zipcode = addressInfo["delivery_postal_code"];
    const delivery_item = USCities.find(
      (entry) => entry.value === delivery_zipcode
    );
    let quoteData = {
      price: priceString,

      pickup_zipcode: pickup_zipcode,
      pickup_city: pickup_item["city"],
      pickup_state: pickup_item["state"],

      delivery_zipcode: delivery_zipcode,
      delivery_city: delivery_item["city"],
      delivery_state: delivery_item["state"],

      is_pallet: isPallet,
      quantity: cargoInfo.quantity,
      length: cargoInfo.length,
      width: cargoInfo.width,
      height: cargoInfo.height,
      weight: cargoInfo.weight,

      pickup_ls: addressInfo.pickup_ls,
      pickup_type: addressInfo.pickup_type,
      delivery_ls: addressInfo.delivery_ls,
      delivery_type: addressInfo.delivery_type,

      pickup_date: cargoInfo.date[0].format("YYYY-MM-DD"),
      delivery_date: cargoInfo.date[1].format("YYYY-MM-DD"),
    };
    props.nextStep(quoteData);
  };

  useEffect(() => {
    updateQuoteButtonStatus();
  }, [isPallet]);

  const updateQuoteButtonStatus = () => {
    const addressInfo = addressForm.getFieldsValue();
    const cargoInfo = cargoForm.getFieldsValue();

    var quoteEnable = true;

    if (
      typeof addressInfo["delivery_postal_code"] === "undefined" ||
      addressInfo["delivery_postal_code"] === null
    ) {
      quoteEnable = false;
    }
    if (
      typeof addressInfo["delivery_type"] === "undefined" ||
      addressInfo["delivery_type"] === null
    ) {
      quoteEnable = false;
    }
    if (
      typeof addressInfo["pickup_postal_code"] === "undefined" ||
      addressInfo["pickup_postal_code"] === null
    ) {
      quoteEnable = false;
    }
    if (
      typeof addressInfo["pickup_type"] === "undefined" ||
      addressInfo["pickup_type"] === null
    ) {
      quoteEnable = false;
    }

    if (
      typeof cargoInfo["date"] === "undefined" ||
      cargoInfo["date"] === null
    ) {
      quoteEnable = false;
    }
    if (
      typeof cargoInfo["weight"] === "undefined" ||
      cargoInfo["weight"] === null
    ) {
      quoteEnable = false;
    }

    if (isPallet) {
      if (
        typeof cargoInfo["quantity"] === "undefined" ||
        cargoInfo["quantity"] === null
      ) {
        quoteEnable = false;
      }
    } else {
      if (
        typeof cargoInfo["height"] === "undefined" ||
        cargoInfo["height"] === null
      ) {
        quoteEnable = false;
      }
      if (
        typeof cargoInfo["length"] === "undefined" ||
        cargoInfo["length"] === null
      ) {
        quoteEnable = false;
      }
      if (
        typeof cargoInfo["width"] === "undefined" ||
        cargoInfo["width"] === null
      ) {
        quoteEnable = false;
      }
    }

    setQuoteButtonEnable(quoteEnable);
  };

  const [quoteButtonEnable, setQuoteButtonEnable] = useState(false);
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [isGotPrice, setIsGotPrice] = useState(false);

  const fetchQuote = async (params) => {
    try {
      // Google analytics custom event log
      glogEvent("shipper_offer", params);

      setQuoteLoading(true);

      const response = await fetch(
        `${BASE_API_URL}/api/v1/app/shipper/order/appraisal/anonymous`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${appCtx.token}`,
          },
          body: JSON.stringify(params),
        }
      );

      if (!response.ok) {
        throw new Error(response);
      }
      const text = await response.text();
      const result = JSONBig({ storeAsString: true }).parse(text);

      if (result.code !== 0) {
        console.log(`request quote api failed:${result}`);
        messageApi.error(result.errmsg);
        return;
      }

      console.log(result.data);
      setPickupCityString(params.pickup_city);
      setDeliveryCityString(params.delivery_city);
      setPriceString(`${result.data.price}`);
      setIsGotPrice(true);
    } catch (error) {
      console.log(`request login api error: ${error}`);
      messageApi.error("网络错误");
    } finally {
      setQuoteLoading(false);
    }
  };

  const [priceString, setPriceString] = useState("-.--");
  const [pickupCityString, setPickupCityString] = useState("");
  const [deliveryCityString, setDeliveryCityString] = useState("");


  const goOrder = (cargoInfo) => {
    if (window.innerWidth < 1000) {
      return goOrderMobile(cargoInfo);
    } else {
      return goOrderPc(cargoInfo);
    }
  }

  const goOrderMobile = (cargoInfo) => {
    return (

<div className="mt-10 bg-white rounded-2xl p-6">
        <div className="text-brand-orange text-[17px] mb-6">
          {useIntl().formatMessage({
            id: "page.quote.price.description",
            description: "以下为您此次货运的估价和预计送货时间：",
          })}
        </div>
        <div className="flex justify-between items-center mb-8">
          <div className="flex flex-col w-2/5">
            {/* 发货地址 */}
            <div className="flex items-center mb-4">
              <div className="w-5 h-5 bg-brand-orange rounded-full mr-2"></div>
              <span className="text-sm">{pickupCityString}</span>
            </div>
            {/* 发货时间 */}
            <div className="flex items-center">
              <img src={calendarIcon} className="w-[18px] h-[18px] mr-2" alt="calendar" />
              <div className="text-sm">{cargoInfo.date[0].format("YYYY-MM-DD")}</div>
            </div>
          </div>

          <div className="w-1/5 flex justify-center">
            <img src={arrowIcon} className="w-8 h-6" alt="arrow" />
          </div>

          <div className="flex flex-col w-2/5">
            {/* 收货地址 */}
            <div className="flex items-center mb-4">
              <div className="w-5 h-5 bg-brand-orange rounded-full mr-2"></div>
              <span className="text-sm">{deliveryCityString}</span>
            </div>
            {/* 收货时间 */}
            <div className="flex items-center">
              <img src={calendarIcon} className="w-[18px] h-[18px] mr-2" alt="calendar" />
              <div className="text-sm">{cargoInfo.date[1].format("YYYY-MM-DD")}</div>
            </div>
          </div>
        </div>

        <div className="text-brand-orange text-[26px] font-semibold mb-6">
          {`$ ${parseFloat(priceString).toFixed(2)}`}
        </div>
        
        <div className="flex justify-center">
          <button
            className="bg-gradient-to-r from-[#ea7e30] to-[#f5be51] text-white px-12 py-3 rounded-lg text-[17px] font-semibold"
            onClick={() => {
              nextStep();
            }}
          >
            {useIntl().formatMessage({
              id: "page.quote.price.next.step",
              description: "去下单",
            })}
          </button>
        </div>
      </div>
    );
  }

  const goOrderPc = (cargoInfo) => {
    return (
      <div className="mt-10 bg-white rounded-2xl p-10">
        <p className="text-brand-orange text-[17px] mb-8">
          {useIntl().formatMessage({
            id: "page.quote.price.description",
            description: "以下为您此次货运的估价：",
          })}
        </p>
        <div className="flex justify-between items-center">
          <div className="flex-1">
            <div className="mb-6">
              <div className="flex items-center mb-2">
                <img src={startIcon} className="w-6 h-6 mr-3" alt="start" />
                <span className="text-gray-600 text-sm">
                  {useIntl().formatMessage({
                    id: "page.quote.price.pickup",
                    description: "取货点",
                  })}
                </span>
              </div>
              <span className="text-black text-lg font-medium">{pickupCityString}</span>
            </div>
            <div className="h-px bg-gradient-to-r from-[#ea7e30] to-[#f5be51] mb-6"></div>
            <div>
              <div className="flex items-center mb-2">
                <img src={endIcon} className="w-6 h-6 mr-3" alt="end" />
                <span className="text-gray-600 text-sm">
                  {useIntl().formatMessage({
                    id: "page.quote.price.delivery",
                    description: "送货点",
                  })}
                </span>
              </div>
              <span className="text-black text-lg font-medium">{deliveryCityString}</span>
            </div>
          </div>
          <div className="flex flex-col items-center ml-10">
            <span className="text-gray-600 text-sm mb-2">
              {useIntl().formatMessage({
                id: "page.quote.price.future",
                description: "预计",
              })}
            </span>
            <span className="text-brand-orange text-[32px] font-bold mb-6">
              {`$ ${parseFloat(priceString).toFixed(2)}`}
            </span>
            <button
              className="bg-gradient-to-r from-[#ea7e30] to-[#f5be51] text-white px-8 py-3 rounded-lg text-[17px] font-semibold"
              onClick={() => {
                nextStep();
              }}
            >
              {useIntl().formatMessage({
                id: "page.quote.price.next.step",
                description: "去下单",
              })}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {contextHolder}
      <Form.Provider
        onFormChange={(changedFields, allFields) => {
          updateQuoteButtonStatus();
          let fields = allFields.changedFields;
          fields.forEach((field) => {
            glogEvent("quote_form_change", {
              field: field.name.join("."), // field name
              value: field.value,
            });
          });
        }}
      >
        {/* Address Information Section */}
        <div className="bg-white rounded-2xl p-10">
          <div className="mb-8">
            <h3 className="text-brand-blue text-[22px] font-normal mb-8">
              {useIntl().formatMessage({
                id: "page.quote.form.session.address",
                description: "地址信息",
              })}
            </h3>

            {/* Top Alert */}
            <div className="flex items-center gap-3 mb-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <img src={topAlertIcon} className="w-5 h-5" alt="alert" />
              <span className="text-yellow-800 text-sm">
                {useIntl().formatMessage({
                  id: "page.quote.top.alert",
                  description: "顶部提示 文案",
                })}
              </span>
            </div>

            <Form
              layout="vertical"
              variant="filled"
              name="address"
              form={addressForm}
              disabled={isGotPrice}
            >
              {/* Address Fields */}
              <div className="space-y-6">
                {/* First Row */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Origin */}
                  <div>
                    <label className="text-black text-sm font-normal mb-2 block">
                      {useIntl().formatMessage({
                        id: "page.quote.form.session.address.label.pickup",
                        description: "发货点",
                      })}
                    </label>
                    <Form.Item name="pickup_postal_code" className="mb-0">
                      <Select
                        showSearch
                        placeholder={useIntl().formatMessage({
                          id: "page.quote.form.session.address.placeholder.pickup",
                          description: "Zip code / city name",
                        })}
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        options={USCities}
                        className="custom-select"
                        size="large"
                      />
                    </Form.Item>
                  </div>

                  {/* Origin Address Type */}
                  <div>
                    <label className="text-black text-sm font-normal mb-2 block">
                      {useIntl().formatMessage({
                        id: "page.quote.form.session.address.label.pickup.type",
                        description: "地址类别",
                      })}
                    </label>
                    <Form.Item name="pickup_type" className="mb-0">
                      <Select
                        placeholder="Residential / Commercial / Other"
                        className="custom-select"
                        size="large"
                      >
                        <Select.Option value="1">
                          {useIntl().formatMessage({
                            id: "page.quote.form.session.address.type.residential",
                            description: "Residential",
                          })}
                        </Select.Option>
                        <Select.Option value="0">
                          {useIntl().formatMessage({
                            id: "page.quote.form.session.address.type.commercial",
                            description: "Commercial",
                          })}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>

                {/* Liftgate Service Checkbox */}
                <Form.Item
                  name="pickup_ls"
                  valuePropName="checked"
                  initialValue={false}
                  className="mb-0"
                >
                  <Checkbox className="text-black text-sm">
                    {useIntl().formatMessage({
                      id: "page.quote.form.session.address.label.pickup.ls",
                      description: "Liftgate service",
                    })}
                  </Checkbox>
                </Form.Item>

                {/* Second Row */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Destination */}
                  <div>
                    <label className="text-black text-sm font-normal mb-2 block">
                      {useIntl().formatMessage({
                        id: "page.quote.form.session.address.label.delivery",
                        description: "收货点",
                      })}
                    </label>
                    <Form.Item name="delivery_postal_code" className="mb-0">
                      <Select
                        showSearch
                        placeholder={useIntl().formatMessage({
                          id: "page.quote.form.session.address.placeholder.delivery",
                          description: "Zip code / city name",
                        })}
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        options={USCities}
                        className="custom-select"
                        size="large"
                      />
                    </Form.Item>
                  </div>

                  {/* Destination Address Type */}
                  <div>
                    <label className="text-black text-sm font-normal mb-2 block">
                      {useIntl().formatMessage({
                        id: "page.quote.form.session.address.label.delivery.type",
                        description: "地址类别",
                      })}
                    </label>
                    <Form.Item name="delivery_type" className="mb-0">
                      <Select
                        placeholder="Residential / Commercial / Other"
                        className="custom-select"
                        size="large"
                      >
                        <Select.Option value="1">
                          {useIntl().formatMessage({
                            id: "page.quote.form.session.address.type.residential",
                            description: "Residential",
                          })}
                        </Select.Option>
                        <Select.Option value="0">
                          {useIntl().formatMessage({
                            id: "page.quote.form.session.address.type.commercial",
                            description: "Commercial",
                          })}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>

                {/* Destination Liftgate Service Checkbox */}
                <Form.Item
                  name="delivery_ls"
                  valuePropName="checked"
                  initialValue={false}
                  className="mb-0"
                >
                  <Checkbox className="text-black text-sm">
                    {useIntl().formatMessage({
                      id: "page.quote.form.session.address.label.delivery.ls",
                      description: "Liftgate service",
                    })}
                  </Checkbox>
                </Form.Item>
              </div>
            </Form>
          </div>
        </div>

        {/* Freight Information Section */}
        <div className="bg-white rounded-2xl p-10">
          <h3 className="text-brand-blue text-[22px] font-normal mb-8">
            {useIntl().formatMessage({
              id: "page.quote.form.session.cargo",
              description: "货物信息",
            })}
          </h3>

          <Form
            layout="vertical"
            variant="filled"
            name="cargo"
            form={cargoForm}
            disabled={isGotPrice}
          >
            <div className="space-y-6">
              {/* Freight Type */}
              <div>
                <label className="text-black text-sm font-normal mb-2 block">
                  {useIntl().formatMessage({
                    id: "page.quote.form.session.cargo.label.pickup.type",
                    description: "货物形式",
                  })}
                </label>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Pallets */}
                  <div
                    className={`${
                      isPallet
                        ? "border-2 border-brand-blue bg-white"
                        : "border border-gray-400 bg-gray-light"
                    } rounded-lg p-6 flex flex-col items-center gap-1 h-20 justify-center cursor-pointer transition-all duration-200 hover:shadow-md`}
                    onClick={() => {
                      if (!isGotPrice && !isPallet) {
                        setIsPallet(true);
                      }
                    }}
                  >
                    <img src={palletIcon} className="w-8 h-6 mb-1" alt="pallet" />
                    <span className={`text-sm ${isPallet ? "text-brand-blue" : "text-black opacity-60"}`}>
                      Pallet(s)
                    </span>
                  </div>

                  {/* Boxes */}
                  <div
                    className={`${
                      !isPallet
                        ? "border-2 border-brand-blue bg-white"
                        : "border border-gray-400 bg-gray-light"
                    } rounded-lg p-6 flex flex-col items-center gap-1 h-20 justify-center cursor-pointer transition-all duration-200 hover:shadow-md`}
                    onClick={() => {
                      if (!isGotPrice && isPallet) {
                        setIsPallet(false);
                      }
                    }}
                  >
                    <img src={boxIcon} className="w-6 h-6 mb-1" alt="box" />
                    <span className={`text-sm ${!isPallet ? "text-brand-blue" : "text-black opacity-60"}`}>
                      Box(es)
                    </span>
                  </div>
                </div>
              </div>

              {/* Quantity and Weight */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {isPallet ? (
                  /* Quantity */
                  <div>
                    <label className="text-black text-sm font-normal mb-2 block">
                      {useIntl().formatMessage({
                        id: "page.quote.form.session.cargo.label.quantity",
                        description: "请选择数量",
                      })}
                      <span className="text-gray-500 text-xs ml-2">
                        {useIntl().formatMessage({
                          id: "page.quote.form.session.cargo.label.sub.pallet.size",
                          description: "货板尺寸 副标题",
                        })}
                      </span>
                    </label>
                    <Form.Item name="quantity" className="mb-0">
                      <InputNumber
                        placeholder="请选择数量"
                        className="w-full custom-input"
                        size="large"
                        min={1}
                        controls={false}
                      />
                    </Form.Item>
                  </div>
                ) : (
                  /* Dimensions */
                  <div>
                    <label className="text-black text-sm font-normal mb-2 block">
                      货物尺寸 (Length x Width x Height)
                    </label>
                    <div className="grid grid-cols-3 gap-2">
                      <Form.Item name="length" className="mb-0">
                        <InputNumber
                          placeholder="长"
                          className="w-full custom-input"
                          size="large"
                          min={0.01}
                          controls={false}
                        />
                      </Form.Item>
                      <Form.Item name="width" className="mb-0">
                        <InputNumber
                          placeholder="宽"
                          className="w-full custom-input"
                          size="large"
                          min={0.01}
                          controls={false}
                        />
                      </Form.Item>
                      <Form.Item name="height" className="mb-0">
                        <InputNumber
                          placeholder="高"
                          className="w-full custom-input"
                          size="large"
                          min={0.01}
                          controls={false}
                        />
                      </Form.Item>
                    </div>
                  </div>
                )}

                {/* Weight */}
                <div>
                  <label className="text-black text-sm font-normal mb-2 block">
                    {useIntl().formatMessage({
                      id: "page.quote.form.session.cargo.label.weight",
                      description: "货物总重量 lbs",
                    })}
                  </label>
                  <Form.Item name="weight" className="mb-0">
                    <InputNumber
                      placeholder="请填写重量"
                      className="w-full custom-input"
                      size="large"
                      min={0.01}
                      controls={false}
                    />
                  </Form.Item>
                </div>
              </div>

              {/* Shipping Date */}
              <div className="w-full lg:w-1/2">
                <label className="text-black text-sm font-normal mb-2 block">
                  {useIntl().formatMessage({
                    id: "page.quote.form.session.cargo.label.date",
                    description: "发货时间",
                  })}
                </label>
                <Form.Item name="date" className="mb-0">
                  <RangePicker
                    locale={
                      currentLanguage.locale.startsWith("zh")
                        ? DatePickerLocaleZH
                        : DatePickerLocaleEN
                    }
                    placeholder={["请选择日期", "请选择日期"]}
                    className="w-full custom-input"
                    size="large"
                    minDate={dayjs()}
                  />
                </Form.Item>
              </div>
            </div>

            {/* Quote Button */}
            {!isGotPrice && (
              <div className="mt-10">
                <Spin spinning={quoteLoading}>
                  <button
                    className={`${
                      quoteButtonEnable
                        ? "bg-gradient-to-r from-[#ea7e30] to-[#f5be51] text-white cursor-pointer"
                        : "bg-gray-400 text-black cursor-not-allowed"
                    } px-20 py-4 rounded-lg text-[17px] font-semibold transition-all duration-200`}
                    disabled={!quoteButtonEnable || quoteLoading}
                    onClick={() => {
                      const addressInfo = addressForm.getFieldsValue();
                      const cargoInfo = cargoForm.getFieldsValue();

                      if (
                        typeof addressInfo["pickup_postal_code"] === "undefined" ||
                        addressInfo["pickup_postal_code"] === null
                      ) {
                        showAlertMessage(intl.formatMessage({
                          id: "page.quote.form.session.address.alert.pickup",
                          description: "请选择取货地",
                        }));
                        addressForm.scrollToField("pickup_postal_code");
                        return;
                      }
                      if (
                        typeof addressInfo["pickup_type"] === "undefined" ||
                        addressInfo["pickup_type"] === null
                      ) {
                        showAlertMessage(intl.formatMessage({
                          id: "page.quote.form.session.address.alert.pickup.type",
                          description: "请选择取货地 地址类型",
                        }));
                        addressForm.scrollToField("pickup_type");
                        return;
                      }

                      if (
                        typeof addressInfo["delivery_postal_code"] === "undefined" ||
                        addressInfo["delivery_postal_code"] === null
                      ) {
                        showAlertMessage(intl.formatMessage({
                          id: "page.quote.form.session.address.alert.delivery",
                          description: "请选择送达地",
                        }));
                        addressForm.scrollToField("delivery_postal_code");
                        return;
                      }
                      if (
                        typeof addressInfo["delivery_type"] === "undefined" ||
                        addressInfo["delivery_type"] === null
                      ) {
                        showAlertMessage(intl.formatMessage({
                          id: "page.quote.form.session.address.alert.delivery.type",
                          description: "请选择送达地 地址类型",
                        }));
                        addressForm.scrollToField("delivery_type");
                        return;
                      }

                      if (!isPallet) {
                        if (
                          typeof cargoInfo["length"] === "undefined" ||
                          cargoInfo["length"] === null
                        ) {
                          showAlertMessage(intl.formatMessage({
                            id: "page.quote.form.session.cargo.alert.length",
                            description: "请填写货物长度",
                          }));
                          cargoForm.scrollToField("length");
                          return;
                        }
                        if (
                          typeof cargoInfo["width"] === "undefined" ||
                          cargoInfo["width"] === null
                        ) {
                          showAlertMessage(intl.formatMessage({
                            id: "page.quote.form.session.cargo.alert.width",
                            description: "请填写货物宽度",
                          }));
                          return;
                        }
                        if (
                          typeof cargoInfo["height"] === "undefined" ||
                          cargoInfo["height"] === null
                        ) {
                          showAlertMessage(intl.formatMessage({
                            id: "page.quote.form.session.cargo.alert.quantity",
                            description: "请填写货物高度",
                          }));
                          return;
                        }
                      } else {
                        if (
                          typeof cargoInfo["quantity"] === "undefined" ||
                          cargoInfo["quantity"] === null
                        ) {
                          showAlertMessage(intl.formatMessage({
                            id: "page.quote.form.session.cargo.alert.quantity",
                            description: "请填写货板数量",
                          }));
                          return;
                        }
                      }

                      if (
                        typeof cargoInfo["weight"] === "undefined" ||
                        cargoInfo["weight"] === null
                      ) {
                        showAlertMessage(intl.formatMessage({
                          id: "page.quote.form.session.cargo.alert.weight",
                          description: "请填写货物总重量",
                        }));
                        return;
                      }

                      if (
                        typeof cargoInfo["date"] === "undefined" ||
                        cargoInfo["date"] === null
                      ) {
                        showAlertMessage(intl.formatMessage({
                          id: "page.quote.form.session.cargo.alert.date",
                          description: "请选择取货时间",
                        }));
                        return;
                      }

                      if (quoteButtonEnable) {
                        const pickup_zipcode = addressInfo["pickup_postal_code"];
                        const pickup_item = USCities.find(
                          (entry) => entry.value === pickup_zipcode
                        );
                        const delivery_zipcode = addressInfo["delivery_postal_code"];
                        const delivery_item = USCities.find(
                          (entry) => entry.value === delivery_zipcode
                        );

                        var params = {
                          pickup_state: pickup_item["state"],
                          pickup_city: pickup_item["city"],
                          pickup_county: pickup_item["county"],
                          pickup_postal_code: pickup_zipcode,
                          delivery_state: delivery_item["state"],
                          delivery_city: delivery_item["city"],
                          delivery_county: delivery_item["county"],
                          delivery_postal_code: delivery_zipcode,
                          is_pallet: isPallet,
                          weight: cargoInfo["weight"],
                          pickup_type: addressInfo.pickup_type,
                          delivery_type: addressInfo.delivery_type,
                          pickup_ls: addressInfo.pickup_ls,
                          delivery_ls: addressInfo.delivery_ls,
                        };
                        if (isPallet) {
                          params["quantity"] = cargoInfo["quantity"];
                        } else {
                          params["length"] = cargoInfo["length"];
                          params["width"] = cargoInfo["width"];
                          params["height"] = cargoInfo["height"];
                        }
                        fetchQuote(params);
                      }
                    }}
                  >
                    {quoteLoading
                      ? " "
                      : useIntl().formatMessage({
                          id: "page.quote.form.submit.button",
                          description: "估价",
                        })}
                  </button>
                </Spin>
              </div>
            )}
          </Form>
        </div>
      </Form.Provider>
      
      {isGotPrice && goOrder(cargoForm.getFieldsValue())}
    </div>
  );
}
